module.exports = __webpack_public_path__ + "img/chicken-heart-sunshine.6902f761.svg";